import { render, staticRenderFns } from "./SettingsWin.vue?vue&type=template&id=7acd2e5e&scoped=true"
import script from "./SettingsWin.vue?vue&type=script&lang=js"
export * from "./SettingsWin.vue?vue&type=script&lang=js"
import style0 from "./SettingsWin.vue?vue&type=style&index=0&id=7acd2e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acd2e5e",
  null
  
)

export default component.exports